import type { UserSummaryBasicInfo } from './userSummaryBasicInfo';
import type { UserSummarySocial } from './userSummarySocial';

/**
 * 간략한 사용자 정보
 */
export interface UserSummary {
  /** 사용자 기본 정보 */
  basicInfo: UserSummaryBasicInfo;
  /** 소셜 관계 정보 */
  social?: UserSummarySocial;
}
